import { Component, ContentChild, Input, OnDestroy, TemplateRef } from '@angular/core';
import { lockScroll, unlockScroll } from '../shared/scroll-lock';

@Component({
  selector: 'app-popup-card',
  templateUrl: './popup-card.component.html',
})
export class PopupCardComponent implements OnDestroy {
  /** Card body — projected via <ng-template #body> inside <app-popup-card> */
  @ContentChild('body', { read: TemplateRef }) bodyTpl!: TemplateRef<any>;
  /** Hover popover content */
  @Input() popupTpl?: TemplateRef<any>;
  /** Click/tap overlay content — falls back to popupTpl if not provided */
  @Input() tapTpl?: TemplateRef<any>;

  /** Extra CSS classes for the card border (e.g. 'border-danger') */
  @Input() cardClass = '';
  /** Max-width of the tap overlay card (e.g. '340px' or '900px') */
  @Input() popupMaxWidth = '640px';

  hovered = false;
  tapped  = false;
  private _timer: any;

  showHover(): void {
    clearTimeout(this._timer);
    this.hovered = true;
  }

  hideHover(): void {
    this._timer = setTimeout(() => { this.hovered = false; }, 150);
  }

  toggleTap(event: Event): void {
    event.stopPropagation();
    this.tapped = !this.tapped;
    if (this.tapped) { this.hovered = false; lockScroll(); }
    else             { unlockScroll(); }
  }

  closeTap(): void {
    if (this.tapped) { this.tapped = false; unlockScroll(); }
  }

  ngOnDestroy(): void {
    clearTimeout(this._timer);
    if (this.tapped) unlockScroll();
  }
}
